enum QuizQuestionTypeNameName {
    Checkboxes = 'Checkboxes',
    MultipleChoice = 'MultipleChoice',
    TrueOrFalse = 'TrueOrFalse',
}

export default QuizQuestionTypeNameName;
